import { DOMAIN, PUBLIC_DOMAIN } from "../constants/env";

export const DOMAIN_API_URI = DOMAIN;
export const PUBLIC_DOMAIN_API_URI = PUBLIC_DOMAIN;
export const PATH_API_URI = "/";

export const MONTH_LIMIT = 12;
